import { Box, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';
import parse from 'html-react-parser';
import Skeleton from '@material-ui/lab/Skeleton';
import { getBeranda } from '../../../services';

const QUERY_NAME = 'Sekilas%20Tentang%20Kami';

const Fade = require('react-reveal/Fade');

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 16px',
    paddingTop: 127,
    '@media screen and (max-width: 1919px)': {
      minHeight: 'initial',
      padding: '6rem 1rem',
    },
  },
  wrapStk: {
    width: '100%',
    maxWidth: 1280,
    display: 'flex',
    gap: 24,
    justifyContent: 'space-between',
    '@media screen and (max-width: 990px)': {
      flexDirection: 'column',
    },
    '@media screen and (min-width: 2560px)': {
      maxWidth: 1780,
    },
  },
  wrapVideo: {
    position: 'relative',
    width: '60%',
    '&::before': {
      content: '""',
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      left: '-20px',
      top: '10%',
      width: '20px',
      height: '20%',
    },
    '@media screen and (max-width: 990px)': {
      width: '100%',
      marginBottom: 32,
    },
    '@media screen and (min-width: 2560px)': {
      width: '60%',
    },
  },
  wrapDesc: {
    width: '45%',
    '@media screen and (max-width: 990px)': {
      width: '100%',
    },
  },
  titleMain: {
    fontSize: 36,
    marginBottom: 32,
    '@media screen and (min-width: 2560px)': {
      fontSize: 60,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 28,
      marginBottom: 24,
    },
  },
  description: {
    fontSize: '30px',
    marginBottom: '2rem',
  },
}));

const SekilasTentangKami = ({ isId }: any) => {
  const [berandaState, setBerandaState] = useState<any>([]);
  const [videoState, setVideoState] = useState<any>(null);
  const [loadingState, setLoadingState] = useState(true);
  const [loadingVideoState, setLoadingVideoState] = useState(true);
  const videoRef = useRef<any>(null);
  const classes = useStyles();
  const history = useHistory();
  const { sekilasTentangKamiId, sekilasTentangKamiEn } = berandaState;

  const fetchBeranda = async () => {
    try {
      const res = await getBeranda();
      setBerandaState(res.data);
      setLoadingState(false);
    } catch (err: any) {
      // setLoadingState(false);
      console.log(err.message);
    }
  };

  const fetchVideo = async () => {
    try {
      const res: any = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/video?name=${QUERY_NAME}`
      );
      const resJson = await res.json();
      setVideoState(resJson.data.filename);
      setLoadingVideoState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchBeranda();
    fetchVideo();
    // window.scrollTo(0, 0);
  }, []);

  return (
    <Box className={classes.root}>
      <Box className={classes.wrapStk}>
        <Box className={classes.wrapVideo}>
          <Fade left>
            {loadingVideoState ? (
              <Skeleton variant='rect' height={300} />
            ) : (
              <video
                ref={videoRef}
                style={{
                  objectFit: 'initial',
                  height: videoRef.current?.offsetWidth / 1.5,
                  width: '100%',
                }}
                autoPlay
                muted
                loop
              >
                <source
                  src={`${process.env.REACT_APP_URL}/videos/${videoState}`}
                  type='video/webm'
                ></source>
              </video>
            )}
          </Fade>
        </Box>
        <Box className={classes.wrapDesc}>
          {loadingState ? (
            <>
              <Skeleton
                variant='rect'
                height={42}
                style={{ marginBottom: 8 }}
              />
              <Skeleton
                variant='rect'
                height={200}
                style={{ marginBottom: 8 }}
              />
              <Skeleton
                variant='rect'
                width={142}
                height={37}
                style={{ marginBottom: 8 }}
              />
            </>
          ) : (
            <Fade right>
              <Box
                style={{
                  height: videoRef.current?.offsetWidth / 1.5 - 50,
                  overflow: 'hidden',
                }}
              >
                <Typography
                  color='primary'
                  variant='h4'
                  className={classes.titleMain}
                >
                  {isId ? 'Sekilas Tentang Kami' : 'A Little About Us'}
                </Typography>
                <div id='content'>
                  {sekilasTentangKamiId &&
                    sekilasTentangKamiEn &&
                    parse(isId ? sekilasTentangKamiId : sekilasTentangKamiEn)}
                </div>
              </Box>

              <Button
                variant='contained'
                color='primary'
                onClick={() => history.push('/tentang-kami/sejarah-perusahaan')}
              >
                {isId ? 'Selengkapnya' : 'More'}
              </Button>
            </Fade>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SekilasTentangKami;
